export const AUTH_TOKEN = 'auth_gm_token';
export const AUTH_USER = 'auth_gm_user';
